<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <mat-progress-spinner></mat-progress-spinner>
    </div>
</div>
